export const HorizontalPackageListing = [
    { span: 24, height: "40px", classes: "marginBottom-16" },
    { span: 24, height: "20px", classes: "marginBottom-24" },

    {
        classes: "flex gap-16",
        columns: [
            { height: "200px", span: 5 },
            { height: "200px", span: 5 },
            { height: "200px", span: 5 },
            { height: "200px", span: 5 },
            { height: "200px", span: 3 },
        ],
    },

    { span: 24, height: "40px", classes: "marginTop-16" },
]

export const HorizontalPackageListingSmall = [
    { span: 6, height: "24px" },
    { span: 6, height: "12px", classes: "mTop-4" },

    {
        classes: "marginTop-12",
        span: 6,
        height: "32px",
    },

    {
        classes: "marginTop-12",
        span: 6,
        height: "220px",
        columns: [
            {
                span: 2,
                height: "220px",
                rows: [
                    { span: 2, height: "90px" },
                    { span: 2, classes: "mTop-4", height: "18px" },
                    { span: 2, classes: "mTop-4", height: "14px" },
                    { span: 1, classes: "mTop-4", height: "16px" },
                    { span: 1, classes: "mTop-4", height: "28px" },
                ],
            },
            {
                span: 2,
                height: "220px",
                rows: [
                    { span: 2, height: "90px" },
                    { span: 2, classes: "mTop-4", height: "18px" },
                    { span: 2, classes: "mTop-4", height: "14px" },
                    { span: 1, classes: "mTop-4", height: "16px" },
                    { span: 1, classes: "mTop-4", height: "28px" },
                ],
            },
            {
                span: 2,
                height: "220px",
                rows: [
                    { span: 2, height: "90px" },
                    { span: 2, classes: "mTop-4", height: "18px" },
                    { span: 2, classes: "mTop-4", height: "14px" },
                    { span: 1, classes: "mTop-4", height: "16px" },
                    { span: 1, classes: "mTop-4", height: "28px" },
                ],
            },
        ],
    },

    { span: 6, height: "16px", classes: "marginTop-12" },
]
